import { Tab, Tabs as MuiTabs } from "@mui/material";
import { CSSProperties, useState } from "react";

export interface TabsProps {
  tabs: { label: string }[];
  onChange?: (val: number) => void;
  activeTab?: number;
  centered?: boolean;
  style?: CSSProperties;
}

export default function Tabs(props: TabsProps) {
  const { centered, style } = props;
  const [value, setValue] = useState(props.activeTab || 0);

  function handleChange(e: React.SyntheticEvent, n: number) {
    setValue(n);
    props.onChange && props.onChange(n);
  }

  return (
    <MuiTabs
      value={value}
      onChange={handleChange}
      variant="scrollable"
      style={{
        borderBottom: "1px solid #dddddd",
        ...style,
      }}
      centered={centered}
    >
      {props.tabs.map((tab, index) => {
        return <Tab key={index} label={tab.label} />;
      })}
    </MuiTabs>
  );
}
